import { KanbanTaskCardHeader } from '../../components/kanban/kanban-task-card-header.tsx';
import { Button } from '@progress/kendo-react-buttons';
import { KanbanTaskCard } from '../../components/kanban/kanban-task-card.tsx';
import type { SamplingTaskCardProps } from './sampling-task-card.types.ts';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faCheck,
  faChevronRight,
  faChevronUp,
  faExclamationTriangle,
  faPencil,
} from '@fortawesome/free-solid-svg-icons';
import { useMemo, useState } from 'react';
import { getSamplingJobValidation } from '../../utils/sampling-job.ts';
import { SamplingJobValidationStatus } from '../../utils/sampling-job.type.ts';
import { KanbanTaskCardBody } from '../../components/kanban/kanban-task-card-body.tsx';
import styles from './sampling-task-card.module.scss';

export function SamplingTaskCard(props: SamplingTaskCardProps) {
  const [showBody, setShowBody] = useState(false);

  const jobValidation = useMemo(() => getSamplingJobValidation(props.data), [props.data]);

  const handleClick = () => {
    if (props.onOpenDialog) props.onOpenDialog({ job: props.data });
  };

  return (
    <KanbanTaskCard {...props}>
      <KanbanTaskCardHeader>
        {jobValidation.status === SamplingJobValidationStatus.okay ? (
          <div className={`${styles.headerIcon} ${styles.okay}`} title={jobValidation.title}>
            <FontAwesomeIcon icon={faCheck} size={'lg'} />
          </div>
        ) : jobValidation.status === SamplingJobValidationStatus.warn ? (
          <div className={`${styles.headerIcon} ${styles.warn}`} title={jobValidation.title}>
            <FontAwesomeIcon icon={faExclamationTriangle} size={'lg'} />
          </div>
        ) : (
          <div className={`${styles.headerIcon} ${styles.error}`} title={jobValidation.title}>
            <FontAwesomeIcon icon={faExclamationTriangle} size={'lg'} />
          </div>
        )}
        <div className={styles.headerSeparator}></div>
        <span className={styles.headerTitle}>{props.data.clientTitle}</span>
        {!props.isOverlay && (
          <div>
            <Button className={styles.headerBtn} onClick={handleClick}>
              <FontAwesomeIcon icon={faPencil} size={'1x'} />
            </Button>
          </div>
        )}
      </KanbanTaskCardHeader>
      {!props.isOverlay && (
        <KanbanTaskCardBody>
          {showBody && <>{props.children}</>}
          {showBody ? (
            <>
              <div className={styles.bodySeparator}></div>
              <div>
                <Button className={styles.linkButton} onClick={() => setShowBody(!showBody)}>
                  <FontAwesomeIcon icon={faChevronUp} size={'1x'} />
                  Hide job info...
                </Button>
              </div>
            </>
          ) : (
            <div>
              <Button className={styles.linkButton} onClick={() => setShowBody(!showBody)}>
                <FontAwesomeIcon icon={faChevronRight} size={'1x'} />
                Show job info...
              </Button>
            </div>
          )}
        </KanbanTaskCardBody>
      )}
    </KanbanTaskCard>
  );
}
